import { render, staticRenderFns } from "./HeroShortModule.vue?vue&type=template&id=2eda5b3e&"
import script from "./HeroShortModule.ts?vue&type=script&lang=ts&"
export * from "./HeroShortModule.ts?vue&type=script&lang=ts&"
import style0 from "./HeroShortModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports